// Compact country dial-code list + E.164 formatter for phone sign-in.
export const COUNTRIES = [
  { code: "US", name: "United States", dial: "1" },
  { code: "IN", name: "India", dial: "91" },
  { code: "GB", name: "United Kingdom", dial: "44" },
  { code: "CA", name: "Canada", dial: "1" },
  { code: "AU", name: "Australia", dial: "61" },
  { code: "AE", name: "United Arab Emirates", dial: "971" },
  { code: "SG", name: "Singapore", dial: "65" },
  { code: "DE", name: "Germany", dial: "49" },
  { code: "FR", name: "France", dial: "33" },
  { code: "JP", name: "Japan", dial: "81" },
  { code: "ZA", name: "South Africa", dial: "27" },
  { code: "KE", name: "Kenya", dial: "254" },
  { code: "NG", name: "Nigeria", dial: "234" },
  { code: "PK", name: "Pakistan", dial: "92" },
  { code: "BD", name: "Bangladesh", dial: "880" },
  { code: "LK", name: "Sri Lanka", dial: "94" },
  { code: "MY", name: "Malaysia", dial: "60" },
  { code: "PH", name: "Philippines", dial: "63" },
  { code: "NZ", name: "New Zealand", dial: "64" },
  { code: "SA", name: "Saudi Arabia", dial: "966" },
  { code: "QA", name: "Qatar", dial: "974" },
  { code: "BR", name: "Brazil", dial: "55" },
];

export function toE164(dial, national) {
  const digits = (national || "").replace(/\D/g, "");
  return `+${String(dial).replace(/\D/g, "")}${digits}`;
}

export function formatNational(national) {
  return (national || "").replace(/[^\d\s-]/g, "");
}
